import React from "react";
import Form from "../../components/quote/Form";
import { makeStyles, Container, Typography, Link } from "@material-ui/core";
import Title from "../../components/about/common/Title";
const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    marginBottom: "5rem",
  },
}));

const Quote = () => {
  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();
  let sendMail = (
    <Link href="mailto:translation@natakallam.com" onClick={preventDefault}>
      translation@natakallam.com
    </Link>
  );
  return (
    <div className={classes.root}>
      <Container>
        <Title
          title="Request for Translation Quote"
          description={`We're glad you're considering NaTakallam for your
          translation/transcription needs! At NaTakallam we onboard qualified
          displaced persons as translators, transcribers and interpreters. The
          below questions will help us provide you with a quote within 1-2
          business days.`}
        />
        <Typography
          style={{ marginTop: "-70px" }}
          variant="body1"
          color="textSecondary"
        >
          Please don't hesitate to reach out with any questions to:&nbsp;
          <Link
            href="mailto:translation@natakallam.com"
            onClick={preventDefault}
          >
            translation@natakallam.com
          </Link>
        </Typography>

        <Form />
      </Container>
    </div>
  );
};

export default Quote;
